export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Tipo de plan\",\n    \"label_other\": \"{{count}} tipos de plan\"\n}\n"